<template>
  <div class="paysense-page options-card-wrapper--full-height">
    <div v-if="templateData.description" class="paysense-page__description">
      {{ templateData.description }}
    </div>
    <div class="paysense-page__info">
      <div class="paysense-page__info-title">Сума до сплати</div>
      <div class="paysense-page__info-container">
        <span v-if="templateData.amount" class="paysense-page__info-amount">
          {{ formatAmount(templateData.amount, templateData.currency) }}
        </span>
        <span v-if="templateData.currency" class="paysense-page__info-currency">
          {{ templateData.currency }}
        </span>
      </div>
    </div>
    <div v-if="templateData.qr_code" class="paysense-page__qr">
      <div id="paysenseQR"></div>
      <div class="paysense-page__qr-title">Відскануйте QR-код на мобільному пристрої</div>
    </div>
    <div v-if="templateData.deep_link" class="paysense-page__alt">АБО</div>

    <a
      v-if="templateData.deep_link"
      :href="templateData.deep_link"
      class="paysense-page__deep-link"
      target="_blank">
      <img src="./assets/sense.svg" alt="" class="paysense-page__deep-link__img" />
      <img src="./assets/separator.svg" alt="" class="paysense-page__deep-link__img" />
      <img src="./assets/superApp.svg" alt="" class="paysense-page__deep-link__img" />
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { MoneyFormatter } from '../../../helpers/Formatting/MoneyFormatter';
import QRCodeStyling from 'qr-code-styling';
import SenseBankImage from './assets/sense.png';
export default {
  mounted() {
    if (this.templateData.qr_code) {
      this.createQrCode();
    }
  },

  data() {
    return {
      qrCode: null,
    };
  },

  computed: {
    ...mapState(['paymentInvoiceData', 'flowData']),

    isMobileSize() {
      return this.screenSize.width <= 480;
    },

    paymentInvoice() {
      return this.paymentInvoiceData ? this.paymentInvoiceData.data || this.paymentInvoiceData : {};
    },

    templateData() {
      const { description, has_return_url, id } = this.paymentInvoice;

      const { amount: mainAmount, currency: mainCurrency } = this.flowData;

      const {
        amount: payloadAmount,
        currency: payloadCurrency,
        requisites,
      } = this.flowData.payload;

      const parseRequisites = () => {
        if (!requisites) {
          return {};
        }

        if (typeof requisites === 'string') {
          try {
            return JSON.parse(requisites);
          } catch (e) {
            return {};
          }
        }

        return requisites;
      };

      const { deep_link, qr_code_data } = parseRequisites();

      const amount = [undefined, null].includes(payloadAmount) ? mainAmount : payloadAmount;

      const currency = [undefined, null].includes(payloadCurrency) ? mainCurrency : payloadCurrency;

      return {
        id,
        description,
        amount,
        currency,
        has_return_url,
        qr_code: deep_link || qr_code_data || '',
        deep_link,
      };
    },
  },

  methods: {
    formatAmount(amount, currency, showCurrency) {
      const formatter = new MoneyFormatter();
      return formatter.format(amount, currency, showCurrency);
    },

    createQrCode() {
      this.qrCode = new QRCodeStyling({
        width: 240,
        height: 240,
        type: 'svg',
        data: this.templateData.qr_code,
        image: SenseBankImage,
        dotsOptions: {
          color: 'black',
          type: 'dots',
        },
        cornersSquareOptions: {
          type: 'extra-rounded',
        },
        cornersDotOptions: {
          type: 'dot',
        },
        imageOptions: {
          imageSize: 0.5,
          margin: 10,
        },
      });

      this.qrCode.append(document.getElementById('paysenseQR'));
    },
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
$--blue-color: #334dff;
$--white-color: #ffffff;

$--label-color-1: #7f8fa4;
$--label-color-2: #334150;
$--card-label-color: #b3bdff;
$--card-value-color: $--white-color;

$--step-bg-color: #f1f3ff;
$--step-label-color-1: $--blue-color;

$--sense-bg-color: #2722ff;
$--button-bg-color: #0020ff;
$--button-hover-bg-color: $--blue-color;
$--button-active-bg-color: #001acc;
$--button-disabled-bg-color: #d6daf5;

.paysense-page {
  &__description {
    text-align: center;
    letter-spacing: 0.5px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: $--label-color-1;
    margin-bottom: 24px;
  }

  &__qr {
    &-title {
      @media (max-width: 480px) {
        display: none;
      }

      margin-top: 20px;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.5px;
      color: $--label-color-2;
      margin-bottom: 4px;
    }
  }

  &__alt {
    @media (min-width: 480px) {
      display: none;
    }

    padding: 4px 0;
    margin: 16px 0;
    position: relative;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #cdd5db;

    &::before,
    &::after {
      content: '';
      position: absolute;
      height: 2px;
      background: #eaecee;
      width: calc(43% - 16px);
      top: calc(50% - 2px);
    }

    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }
  }

  &__deep-link {
    @media (min-width: 480px) {
      display: none;
    }

    padding: 9px 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 6px;
    background: $--sense-bg-color;
    width: 100%;
    max-width: 311px;
    height: 40px;
    margin: 0 auto 24px;
    cursor: pointer;

    @media (max-width: 480px) {
      margin: 0 auto 16px;
    }

    &__text {
      letter-spacing: 0.5px;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: $--white-color;
    }
  }

  &__info {
    margin-bottom: 20px;

    &-title {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.5px;
      color: $--label-color-1;
      margin-bottom: 4px;
    }

    &-amount {
      margin-right: 8px;
    }

    &-container {
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: 1px;
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
      color: $--label-color-2;
    }
  }
}
</style>
